import { initRelatedTagsRenderer } from '../ts/components/related-tags/RelatedTagsRenderer';
import getRelatedTagsView from '@hooks/relatedTagsView';
/**
 * Default hook for the HOME page type.
 *
 * Initialises the related-tags renderer using the project-level view contract.
 * The renderer gracefully handles the case when no .related-tags-root[data-tags-json] exists.
 *
 * To override, create: projects/<id>/ui/hooks/onHome.ts
 */
export default async function onHome(_context) {
    const contract = getRelatedTagsView();
    await initRelatedTagsRenderer(contract);
}
